/**
 * Matters Service
 *
 * This module provides a comprehensive service for managing probate matters,
 * including types, actions, utilities, and React hooks.
 */

export * from './types';

// Reads + mutations (LF-3215 / LF-3216 — directApiClient).
// Server-side reads flow through `lib/data/matter-reads.ts`.
export * from './client';

export * from './utils';

export * from './hooks';
